import React, { useEffect } from 'react'
import Courtage from '../courtage/Courtage'
import CourtageNote from '../courtageNote/CourtageNote'
import { FieldProps } from '../../../../../../../@types/types'
import HasCourtage from '../hasCourtage/HasCourtage'

export type CourtageGroupValidationResult = {
  courtage?: string[]
  courtageNote?: string[]
}
const CourtageGroup: React.FC<FieldProps<CourtageGroupValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  doReset,
  onChange,
}) => {
  useEffect(() => {
    if (!insertionData.hasCourtage) {
      doReset?.([
        { screen: screenName, property: 'courtage' },
        { screen: screenName, property: 'courtageNote' },
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insertionData.hasCourtage])

  const wrapperProps = { screenName, insertionData, validationMessages, onChange }

  return (
    <div className='grid-item one-whole'>
      <HasCourtage {...wrapperProps} />
      {insertionData.hasCourtage && (
        <>
          <Courtage {...wrapperProps} />
          <CourtageNote {...wrapperProps} />
        </>
      )}
    </div>
  )
}

export default CourtageGroup
